// extracted by mini-css-extract-plugin
module.exports = {"filters":"OnSaleList_filters__1NNZ_","search":"OnSaleList_search__2XCSD","pagination":"OnSaleList_pagination__UOq_k","empty":"OnSaleList_empty__3EENa"};